<ng-content></ng-content>
<div class="text-right counter-container">
  <span class="caption text-darkgray counter">
    {{ value?.length || 0 }}
    @if (withLimit) {
      /{{ withLimit }} {{ 'common.validation.character_limit' | translate }}
    } @else {
      {{ 'common.validation.characters' | translate }}
    }
  </span>
</div>
